// Utils
import { http } from '../../utils/services/http';

// Selectors
import { getClosestPermissionIdForElementIdSelector } from '../../utils/permissions/permissionsSelector';
import { getCurrentBoardIdFromState } from '../../reducers/currentBoardId/currentBoardIdSelector';

// Constants
import { METHODS } from '../../../common/utils/http/httpConstants';

export const submitContentReport =
    ({ boardId, email, reason, otherDetails, contactUser, source }) =>
    async (dispatch, getState) => {
        const state = getState();

        const elementId = boardId || getCurrentBoardIdFromState(state);

        const permissionId = getClosestPermissionIdForElementIdSelector()(state, { elementId });

        return http({
            url: '/content-reports',
            method: METHODS.POST,
            data: {
                boardId,
                permissionId,
                contactUser,
                email,
                reason,
                otherDetails,
                source,
            },
        });
    };
